export enum EAdminPostType {
  All = 'All',
  course = 'course',
  lessons = 'lesson',
  learnArticles = 'learnArticle',
  careArticle = 'careArticle',
  taskArticle = 'taskArticle',
}

export interface AdminSearchResult {
  itemType: EAdminPostType
  itemId: number
  isPublished: false
  name: string
  talkTime: number
  createdAt: string
  updatedAt: string
}
